var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import Outline from './outline';
import { inject, observer } from 'mobx-react';
var CustomFieldCheckbox = /** @class */ (function (_super) {
    __extends(CustomFieldCheckbox, _super);
    function CustomFieldCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.field.value
        };
        return _this;
    }
    Object.defineProperty(CustomFieldCheckbox.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var options = (_a = this.props.field.options) === null || _a === void 0 ? void 0 : _a.map(function (o, index) {
                var _a;
                return (_jsx(FormControlLabel, { label: (_a = _this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel(o.name, o.value), control: _jsx(Checkbox, { color: "primary", checked: _this.isOptionSelected(index), onChange: function (e) { return _this.onValueChanged(e, index); } }, void 0) }, index));
            });
            return (_jsx(Outline, __assign({ label: this.props.label }, { children: options }), void 0));
        }
    });
    Object.defineProperty(CustomFieldCheckbox.prototype, "isOptionSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (optionIndex) {
            var _a;
            var checkedValues = this.props.field.value ? (_a = this.props.field.value) === null || _a === void 0 ? void 0 : _a.split(',') : [];
            var option = this.props.field.options[optionIndex];
            return checkedValues.indexOf(option.value) !== -1;
        }
    });
    Object.defineProperty(CustomFieldCheckbox.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, optionIndex) {
            var _a, _b;
            var checkedValues = this.props.field.value ? (_a = this.props.field.value) === null || _a === void 0 ? void 0 : _a.split(',') : [];
            var option = this.props.field.options[optionIndex];
            var isChecked = e.target.checked;
            if (isChecked) {
                if (checkedValues.indexOf(option.value) === -1)
                    checkedValues.push(option.value);
            }
            else {
                var index = checkedValues.indexOf(option.value);
                if (index !== -1)
                    checkedValues.splice(index, 1);
            }
            var newValue = checkedValues.join(',');
            (_b = this.props.fieldsStore) === null || _b === void 0 ? void 0 : _b.updateFieldValue(this.props.field, newValue);
        }
    });
    CustomFieldCheckbox = __decorate([
        inject('fieldsStore'),
        inject('languageStore'),
        observer
    ], CustomFieldCheckbox);
    return CustomFieldCheckbox;
}(React.Component));
export default CustomFieldCheckbox;
